module.exports = function (name, data, callback) {
    var goalId = undefined;

    for (var i = 0; i < window.goalIds.length; i++) {
        var goal = window.goalIds[i];
        if (goal.name === name) {
            goalId = goal.id;
            break;
        }
    }

    if (!goalId) {
        console.error('Failed to find id for event name ', name);
        return;
    }

    $.post('/icfapi/analytics/trackgoal', { 'goalId': goalId, 'data': data }, function (responseData) {
        if (callback) {
            callback(responseData);
        }
    });
};